var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgenciesFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74998 6.90001C5.28053 6.90001 4.89998 7.28056 4.89998 7.75001C4.89998 8.21945 5.28053 8.60001 5.74998 8.60001H7.24998C7.71942 8.60001 8.09998 8.21945 8.09998 7.75001C8.09998 7.28056 7.71942 6.90001 7.24998 6.90001H5.74998Z",
    fill: "var(--primary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89998 15C4.89998 14.3925 5.39246 13.9 5.99998 13.9H6.99998C7.60749 13.9 8.09998 14.3925 8.09998 15V18C8.09998 18.6075 7.60749 19.1 6.99998 19.1H5.99998C5.39246 19.1 4.89998 18.6075 4.89998 18V15Z",
    fill: "var(--primary-6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.69654C13 3.82813 12.4258 3.06156 11.5851 2.8075L2.58511 0.0877658C1.29965 -0.30069 0 0.64902 0 1.97681V22.0245C0 23.1156 0.895431 24 2 24H13.0001L13 4.69654ZM3.09998 7.75001C3.09998 6.28645 4.28642 5.10001 5.74998 5.10001H7.24998C8.71353 5.10001 9.89998 6.28645 9.89998 7.75001C9.89998 9.21356 8.71353 10.4 7.24998 10.4H5.74998C4.28642 10.4 3.09998 9.21356 3.09998 7.75001ZM5.99998 12.1C4.39835 12.1 3.09998 13.3984 3.09998 15V18C3.09998 19.6016 4.39835 20.9 5.99998 20.9H6.99998C8.6016 20.9 9.89998 19.6016 9.89998 18V15C9.89998 13.3984 8.6016 12.1 6.99998 12.1H5.99998Z",
    fill: "var(--primary-6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 18.0078C18.5686 18.0078 18.3 18.2801 18.3 18.6159C18.3 18.9518 18.5686 19.2241 18.9 19.2241H19.9C20.2314 19.2241 20.5 18.9518 20.5 18.6159C20.5 18.2801 20.2314 18.0078 19.9 18.0078H18.9Z",
    fill: "var(--primary-6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8182 24L15 24V9.99999L22.2632 12.1458C23.2749 12.3653 24 13.294 24 14.3704V21.7276C24 22.9826 23.0232 24 21.8182 24ZM16.5 18.6159C16.5 17.2724 17.5745 16.1832 18.9 16.1832H19.9C21.2255 16.1832 22.3 17.2724 22.3 18.6159C22.3 19.9595 21.2255 21.0487 19.9 21.0487H18.9C17.5745 21.0487 16.5 19.9595 16.5 18.6159Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenciesFilled);
export default __webpack_public_path__ + "static/media/agenciesFilled.1e3b2fc2f806d62c7828425e7ceff15f.svg";
export { ForwardRef as ReactComponent };